import { useTranslation } from "react-i18next"
import { Box, Tooltip } from "@mui/material"
import type { DateTime } from "luxon"

import useNow from "helpers/hooks/useNow"
import { formatDateTime, formatRelativeTime } from "helpers/utils/dateUtils"

const TICK_INTERVAL = 30 * 1000

interface RelativeTimeProps {
  date: DateTime
  short?: boolean
}

/**
 * How long ago the date was, such as "2 minutes ago", with the exact date in a
 * tooltip. It updates on its own as time goes by.
 */
const RelativeTime = ({ date, short = false }: RelativeTimeProps) => {
  const { t, i18n } = useTranslation()
  const now = useNow(TICK_INTERVAL)

  return (
    <Tooltip
      title={date.isValid ? formatDateTime(date) : ""}
      enterTouchDelay={0}
      describeChild
    >
      <Box component="time" dateTime={date.toISO() ?? undefined}>
        {formatRelativeTime(date, {
          now,
          locale: i18n.resolvedLanguage,
          aMomentAgo: t("dates.A_MOMENT_AGO"),
          short,
        })}
      </Box>
    </Tooltip>
  )
}

export default RelativeTime
